import client from './api-client';

export const getConfiguracionForm30 = async(query) => {
    try {
        
        const response = await client.get(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form30: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getDatosImplicadoTercero = async(query) => {
    try {
        
        const response = await client.getSelect(`caso/implicado/terceros?q=${query}`);      
        if (response.status === 200 && response.data.code === 1) {
            return {
                datosImplicadoTercero: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getComboDocumentos = async(query) => {
    try {
        
        const response = await client.getDoc(`tipos-documento?q=${query}`); 
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboDocumentos: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getUrlCarpeta = async(query) => {
    try {
        
        const response = await client.getDoc(`cfg-cd?q=${query}`); 
        if (response.status === 200 && response.data.code === 200) {
            return {
                respuestaUrl: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

